__turbopack_context__.v({
  "contactInfoRow": "NewOrderOutletDetails-module-scss-module__MOaYgq__contactInfoRow",
  "contactInfoRows": "NewOrderOutletDetails-module-scss-module__MOaYgq__contactInfoRows",
  "grow": "NewOrderOutletDetails-module-scss-module__MOaYgq__grow",
  "header": "NewOrderOutletDetails-module-scss-module__MOaYgq__header",
  "infoButton": "NewOrderOutletDetails-module-scss-module__MOaYgq__infoButton",
  "left": "NewOrderOutletDetails-module-scss-module__MOaYgq__left",
  "orderFormatIcon": "NewOrderOutletDetails-module-scss-module__MOaYgq__orderFormatIcon",
  "orderFormats": "NewOrderOutletDetails-module-scss-module__MOaYgq__orderFormats",
  "outletName": "NewOrderOutletDetails-module-scss-module__MOaYgq__outletName",
  "right": "NewOrderOutletDetails-module-scss-module__MOaYgq__right",
  "row": "NewOrderOutletDetails-module-scss-module__MOaYgq__row",
  "statusWrapper": "NewOrderOutletDetails-module-scss-module__MOaYgq__statusWrapper",
  "unavailableInfo": "NewOrderOutletDetails-module-scss-module__MOaYgq__unavailableInfo",
});
